<template>
    <div>
       
        <login/>
    </div>
</template>
<script>
import login from '@/components/Login'
export default {
     components: {      
        login
     },
    
     data: () => ({
            name: 'Login',
            
      }),
      mounted(){
           this.$parent.$children[0].$parent.ttlval = this.name
      },
      
}
</script>
<style scoped>

</style>